
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/coach",
      function () {
        return require("private-next-pages/coach/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/coach"])
      });
    }
  